import React from 'react'
import { Link } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TableVirtuoso  } from 'react-virtuoso';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { Box, Drawer, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { getEventsMasterMappingData, getReceiveMessageMappingData } from '../../../api/mappingApi';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';

const columns = [
    { id: 'Addr', label: 'Address',width:130},
    { id: 'EnglishText', label: 'English Text', width:350},
    { id: 'Config', label: 'Configurations',width:250},
    { id: 'MasterMapping', label: 'Master Config',width:160},
    { id: 'Actions', label: 'Actions',width:190}
];

const subColumns = [
    { id: 'Addr', label: 'Address'},
    { id: 'ETxt', label: 'English Text'},
    { id: 'PGN', label: 'PGN'},
    { id: 'SPN', label: 'SPN'},
    { id: 'StartByte', label: 'StartByte'},
    { id: 'StartBit', label: 'StartBit'},
    { id: 'Len', label: 'LengthBits'},
    { id: 'Scaling', label: 'Scaling'},
    { id: 'Offset', label: 'Offset'},
    { id: 'MxVldScaledVal', label: 'MaxScaledValue'},
    { id: 'DType', label: 'ParameterDataType'},
    { id: 'Persistent', label: 'Persistent'}
];

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});


const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align={column.numeric || false ? 'right' : 'left'}
            style={{ width: column.width }}
            sx={{
              backgroundColor: 'background.paper',
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
}

const MappingMessageTable = ({data,handleRowDelete,setShowLoader}) => {
    const [open, setOpen]                   =   React.useState(false);
    const [tableData, setTableData]         =   React.useState(false);
    const [modalType, setModalType]         =   React.useState('');
    const [jsonRowData, setJsonRowData]     =   React.useState('');
    const [openDrawer, setOpenDrawer]       =   React.useState(false);
    const tableHeight = data?.length === 1 ? 240 : data?.length === 2  ? 420 : 600;
    const handleClickOpen = async (rowData,type) => {
        setOpen(true);
        setModalType(type);
        setShowLoader(true);
        const materMappingData = await getReceiveMessageMappingData(rowData.Addr);
        setShowLoader(false);
        setTableData(materMappingData);
    };

    const handleClose = () => {
        setOpen(false);
        setModalType('')
        setJsonRowData('')
    };

    const handleDrawer = (rowData) => {
        setOpenDrawer(true);
        setJsonRowData(rowData);
    }

    const Row = ({index}) => {
        const row = data[index];
        const {EnglishText,...otherKeys} = row;
        const rowData =  JSON.stringify(otherKeys,null,2);
        let trimJsonData;
        if(rowData.length <= 50) {
            trimJsonData = rowData;
        } else {
            trimJsonData = rowData.substring(0,50) + ' ...';
        }
        return (
            <>
                {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                                ? column.format(value)
                                :  column.id === 'MasterMapping' ?
                                    <IconButton
                                    color="inherit"
                                    title="Master Mapping List"
                                    onClick={() => handleClickOpen(row,'mapping')}
                                    >
                                        <InfoRoundedIcon />
                                    </IconButton>
                                :  column.id === 'Actions' ?
                                    <>
                                        <IconButton
                                            color="inherit"
                                            style={{ backgroundColor: 'transparent' }}
                                            title="View Full Configurations"
                                            onClick={() => handleDrawer(rowData)}
                                        >
                                            <OpenInFullRoundedIcon />
                                        </IconButton>
                                        <IconButton
                                            color="inherit"
                                            title="Edit Data"
                                            component={Link} 
                                            to="/mapping/can/receive-messages/edit"
                                            state={{ addressId : row.Addr}}
                                        >
                                            <EditRoundedIcon />
                                        </IconButton>
                                        <IconButton
                                            color="error"
                                            title="Delete Row"
                                            onClick={() => handleRowDelete(index)}
                                        >
                                            <DeleteRoundedIcon />
                                        </IconButton>
                                    </>
                                    : column.id === 'Config' ? 

                                    <pre style={{whiteSpace:'pre-wrap',wordWrap:'break-word',fontFamily:'Roboto,sans-serif',lineHeight:'18px',fontSize:'13px'}}>
                                        {trimJsonData}
                                    </pre>
                                : value
                            }
                        </TableCell>
                    );
                })}
            </>
        )
    }

    return (
        <>
            { data?.length > 0 &&
                <Paper style={{ height:tableHeight, width: '100%' }}>            
                    <TableVirtuoso 
                        className='TableVirtuoso'
                        totalCount={data?.length}
                        data={data}
                        components={VirtuosoTableComponents}
                        fixedHeaderContent={fixedHeaderContent}
                        itemContent={(index) => (<Row index={index} />)}
                        useWindowScroll={false}
                    />   
                </Paper> 
            }
            <Dialog
                closeAfterTransition={false}
                fullWidth={modalType === 'mapping' ? false : true}
                maxWidth={modalType === 'mapping' ? 'sm' : 'md'}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>{modalType === 'mapping' ? 'Master Mapping List' : 'Configurations'}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>
                <DialogContent dividers>
                    {modalType === 'mapping' &&
                        <Table>
                            <TableBody>
                                <Box className="collapseTable" sx={{ height:"300px",marginTop: 2, marginBottom:2 }}>
                                    <PerfectScrollbar>
                                        { Object.keys(tableData).map((keyIndex) => {
                                            const label = subColumns.map(col => keyIndex === col.id ? col.label : '' )
                                            return (
                                                <TableRow>
                                                    <TableCell><strong>{label}</strong></TableCell>
                                                    <TableCell>{tableData[keyIndex]}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </PerfectScrollbar>
                                </Box>    
                            </TableBody>
                        </Table>
                    }

                    {modalType === 'config' &&
                    <TextField 
                        className='jsonTextArea'
                        value={jsonRowData}
                        InputProps={{
                            rows: 10,
                            multiline: true,
                            inputComponent: 'textarea',
                        }} 
                    />            
                    }

                </DialogContent>
            </Dialog>
            <Drawer
                open={openDrawer}
                anchor={"right"}
                onClose={() => setOpenDrawer(false)}
            >
                
                <Box sx={{p:2,width:{ md: 500, xs:250 }}} >
                    <pre style={{whiteSpace:'pre-wrap',wordWrap:'break-word',fontFamily:'Roboto,sans-serif',lineHeight:'30px'}}>
                        {jsonRowData}
                    </pre>
                </Box>
            </Drawer>
        </>
    )
}

export default MappingMessageTable